import PropTypes from 'prop-types';
import { Component } from 'react';
import ReactDOM from 'react-dom';
import { Svg } from './Svg.js';

// Consider using LightBoxWrapper instead. (It's not a replacement for this per se -
// both were written at the same time - but LightBoxWrapper's API makes more sense.)
export class LightBox extends Component {
    constructor(props, context) {
        super(props, context);

        this.popup = document.createElement('div');
    }

    componentDidMount() {
        // (Very) Old versions of WebKit set scroll position on document.body.
        // New versions (and other browsers) set it on document.documentElement.
        // See https://bugs.chromium.org/p/chromium/issues/detail?id=157855
        // It defaults to 0, which is falsy, so this || should work.
        this.initialScroll = document.documentElement.scrollTop || document.body.scrollTop;
        window.scrollToPageTop();

        $('body').prepend(this.popup);
    }

    componentWillUnmount() {
        document.body.removeChild(this.popup);
        // Scroll back to where we were at the start.
        // One of these assignments will have no effect - see comment re this.initialScroll assignment above
        document.documentElement.scrollTop = this.initialScroll;
        document.body.scrollTop = this.initialScroll;
    }

    render() {
        return ReactDOM.createPortal((
            <div>
                <div onClick={this.props.lightboxCloseHandler} className={'screen on' + (this.props.tier === 2 ? ' second-tier' : (this.props.tier === 3 ? ' third-tier' : ''))} />
                <div className={'overlay large on' + (this.props.tier === 2 ? ' second-tier' : (this.props.tier === 3 ? ' third-tier' : ''))}>
                    <div className="overlay-close">
                        <a tabIndex="0" aria-label="close" onClick={this.props.lightboxCloseHandler}>
                            <Svg icon="delete" attributes={{ role: 'presentation' }} additionalClasses="is-button"/>
                        </a>
                    </div>
                    {this.props.content}
                </div>
            </div>
        ), this.popup);
    }
}

LightBox.propTypes = {
    lightboxCloseHandler: PropTypes.func.isRequired,
    content: PropTypes.node,
    tier: PropTypes.number,
};
